export function createFormGateHandlers(component) {
    return {
        buttonWrapperClick: () => {
            component.triggerWidgetStart()
        },
        formKeypress: (event) => {
            if (event.key === 'Enter' && !component.hasCaptchaSolution()) {
                event.preventDefault()
                component.queuePendingSubmit('requestSubmit', component.buttonElement)
                component.triggerWidgetStart()
            }
        },
        formSubmit: (event) => {
            if (component.hasCaptchaSolution()) {
                return
            }

            event.preventDefault()
            component.queuePendingSubmit('requestSubmit', event.submitter || component.buttonElement)
            component.triggerWidgetStart()
        }
    }
}

const formGate = {
    attachFormGate() {
        if (!this.config.submitGate || !this.widget || this.eventListenersAttached) {
            return
        }

        this.boundHandlers = {
            ...this.boundHandlers,
            ...createFormGateHandlers(this)
        }

        if (this.buttonWrapper) {
            this.buttonWrapper.addEventListener('click', this.boundHandlers.buttonWrapperClick)
        }

        this.form.addEventListener('keypress', this.boundHandlers.formKeypress)
        this.form.addEventListener('submit', this.boundHandlers.formSubmit)
        this.form.friendlyCaptchaStart = () => {
            this.triggerWidgetStart()
        }

        this.form.submit = () => {
            if (!this.hasCaptchaSolution()) {
                this.queuePendingSubmit('submit')
                this.triggerWidgetStart()
                return
            }

            this.originalFormSubmit()
        }

        if (this.originalRequestSubmit) {
            this.form.requestSubmit = (submitter) => {
                if (!this.hasCaptchaSolution()) {
                    this.queuePendingSubmit('requestSubmit', submitter || this.buttonElement)
                    this.triggerWidgetStart()
                    return
                }

                this.originalRequestSubmit(submitter)
            }
        }

        this.eventListenersAttached = true
    },

    detachFormGate() {
        if (this.buttonWrapper && this.boundHandlers.buttonWrapperClick) {
            this.buttonWrapper.removeEventListener('click', this.boundHandlers.buttonWrapperClick)
        }

        if (this.form && this.boundHandlers.formKeypress) {
            this.form.removeEventListener('keypress', this.boundHandlers.formKeypress)
        }

        if (this.form && this.boundHandlers.formSubmit) {
            this.form.removeEventListener('submit', this.boundHandlers.formSubmit)
        }

        this.detachOffcanvasStart()

        if (this.form && this.originalFormSubmit) {
            this.form.submit = this.originalFormSubmit
        }

        if (this.form && this.originalRequestSubmit) {
            this.form.requestSubmit = this.originalRequestSubmit
        }

        this.eventListenersAttached = false
    }
}

export default formGate
